import Reflux from 'reflux';
import UserData from 'shared/data/User';

var async = { asyncResult: true },
  SignupActions = Reflux.createActions({
    resendInviteToken: async,
    getByInviteToken: async,
    emailInputChanged: {},
    switchScene: {},
    updateName: {},
    toggleLogin: {},
    displaySignup: {},
  });

SignupActions.resendInviteToken.listenAndPromise(UserData.resendInviteToken);
SignupActions.getByInviteToken.listenAndPromise(UserData.getByInviteToken);

export default SignupActions;
